import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  faRightLeft,
  faPlus,
  faGrid2,
  faSearch
} from "@fortawesome/pro-regular-svg-icons";

import { Button } from "~/components/Button";
import { Footer as FooterLayout } from "~/components/Footer";
import { NetworkStatus } from "~/components/network-status/network-status";
import { UnattendedLogoutButton } from "~/components/UnattendedLogoutButton";
import { CollectLeaveGuard } from "~/components/pos/collect/collect-leave-guard";
import { SplitPaymentGuard } from "~/components/pos/payment/split-payment-guard";
import { useCurrentTill } from "~/api/tills/hooks/use-till-current";
import { T } from "@repo/transifex";
import { useSplitPaymentFlow } from "~/hooks/use-split-payment-flow";
import { useEmployee } from "~/providers/store/employee";
import { hasAttendedSellConfig } from "~/utils/tills/has-attended-sell-config";

import { RedeemRewardsLink } from "./redeem-rewards-link";

export const Footer = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const { data: till } = useCurrentTill();

  const { isActive: isSplitPaymentActive } = useSplitPaymentFlow();
  const { employeeChildId } = useEmployee();

  const Guard = isSplitPaymentActive ? SplitPaymentGuard : CollectLeaveGuard;

  if (!hasAttendedSellConfig(till)) {
    return (
      <FooterLayout>
        <div className="flex w-full items-center justify-between">
          <UnattendedLogoutButton />

          <RedeemRewardsLink />
        </div>
      </FooterLayout>
    );
  }

  return (
    <FooterLayout>
      <div className="flex w-full items-center justify-between">
        <div className="flex items-center gap-3">
          <Guard>
            <Button
              className="shadow"
              icon={faGrid2}
              onClick={() => {
                navigate("/home");
              }}
              variant="secondary-inverted"
            />
          </Guard>

          <Guard>
            <Button
              icon={faRightLeft}
              variant="transparent"
              onClick={() => {
                navigate("/settings/transactions", {
                  state: {
                    showBackButton: true
                  }
                });
              }}
            >
              <T _str="Transactions" />
            </Button>
          </Guard>

          {till.type === "collect" ||
          (till.type === "attended" && till.config.hasChildrenSearch) ? (
            <Guard>
              <Button
                onClick={() => {
                  navigate("/pos/search-children");
                }}
                icon={faSearch}
                variant="transparent"
              >
                <T _str="Find a user" />
              </Button>
            </Guard>
          ) : null}

          {hasAttendedSellConfig(till) && till.config.hasGroupSearch ? (
            <Guard>
              <Button
                onClick={() => {
                  navigate("/pos/search-group");
                }}
                icon={faSearch}
                variant="transparent"
                disabled={employeeChildId !== null}
              >
                <T _str="Find a group" />
              </Button>
            </Guard>
          ) : null}
        </div>

        <div className="flex items-center gap-3">
          <NetworkStatus />

          <RedeemRewardsLink />

          <SplitPaymentGuard>
            <Link to={`${pathname}/custom-product`}>
              <Button
                disabled={isSplitPaymentActive}
                icon={faPlus}
                variant="light"
              >
                <T _str="Create" />
              </Button>
            </Link>
          </SplitPaymentGuard>
        </div>
      </div>
    </FooterLayout>
  );
};
